import { type CollectionModel, CollectionModelFieldImage, CollectionModelFieldTrueSize } from '@ikegps/core-shared';
import { T, Translate } from '../../../i18n';
import { AppStore } from '../../../store';
import type { ImageReference } from '../components/ImageComponent';
import { ImageWithTitle } from '../components/ImageWithTitle';
import { TitleBar } from '../components/TitleBar';
import { captureReferenceString, compositeURL, hasUserMeasurement, isCaptureHidden } from '../ReportHelpers';
import { ReportBase } from './ReportBase';
export class ReportPhoto extends ReportBase {
	constructor(poles: CollectionModel[]) {
		super(poles);
	}

	buildPDF(): void {
		this.poles.forEach((pole, i) => {
			const job = AppStore.Tag.get(pole.jobId);

			// Title
			const poletitle = new TitleBar(
				pole.title || Translate(T.COLLECTION_MISSING_TITLE),
				job.name,
				i + 1,
				this.poles.length
			);
			let isFirstCaptureForPole = true;

			pole.forEachField((field) => {
				// Normal and True Size images
				if (field instanceof CollectionModelFieldTrueSize || field instanceof CollectionModelFieldImage) {
					const isTrueSizeField = field instanceof CollectionModelFieldTrueSize;
					const captures = field.getOwnedCaptures();
					captures.forEach((capture, j) => {
						if (!isCaptureHidden(pole, capture.objectId)) {
							const imageReferenceString = captureReferenceString(pole, capture);
							const hasCrop = pole.getCropParameterState(capture.objectId).useInExportCorrections();
							// Use composite for TrueSize fields (measurements) or when crop is set, otherwise use medium (zoom)
							this.images[imageReferenceString] =
								isTrueSizeField || hasCrop ? compositeURL(pole, capture) : capture.medium.url;
							const imgReference: ImageReference = { reference: imageReferenceString };

							// If the image doesnt have any measurements, attach the timestamp to the image
							if (!hasUserMeasurement(pole, capture.objectId)) {
								imgReference.timeStamp = new Date(capture.createdAt);
							}

							this.nodes.push(
								new ImageWithTitle(field.schema.displayName, imgReference, {
									sectionTitle: isFirstCaptureForPole ? poletitle : undefined,
									pageBreak: i === 0 && isFirstCaptureForPole ? 'none' : 'before',
								})
							);
							isFirstCaptureForPole = false;
						}
					});
				}
			});
		});
	}
}
